import InterruptionRegister from "./InterruptionRegister";
import InterruptionList from "./InterruptionList";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import UserPermission from '../../components/UserPermission';
import MultiManual from '../../components/Manual/MultiManual';

export default function Interruption() {

    const [refresh, setRefresh] = useState(true);
    const history = useNavigate();
    const userPermission = UserPermission();

    useEffect(() => {
        if (userPermission !== 'admin') {
            toast.error("Seu usuário não possuí privilégios para acessar essa página!");
            history("/search");
        }
    }, [userPermission, history]);

    if (userPermission !== 'admin') {
        return null;
    }

    return (
        <>
            <InterruptionRegister refresh={refresh} setRefresh={setRefresh} />

            <hr style={{ margin: '20px' }}></hr>

            <InterruptionList refresh={refresh} setRefresh={setRefresh} />


            <MultiManual
                components={[
                    {
                        id: 'form-inputs',
                        message: 'Você pode preencher este formulário com os dados de uma nova interrupção',
                        rect: { height: 20, top: 100 }
                    },
                    {
                        id: 'register-button',
                        message: 'Aperte o botão para confirmar o cadastro',
                        rect: { height: 20 }
                    },
                    {
                        id: 'interruptions-list',
                        message: 'Aqui é a lista de interrupções',
                        rect: { height: 20 }
                    }

                ]}
             />
        </>
    )
}